var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-buy-prices")))]),
              _c(
                "w-card-content",
                [
                  _vm.product.Suppliers.length == 0
                    ? _c(
                        "w-row",
                        [
                          _c("w-col", { attrs: { xs: "12" } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$ct(
                                    "this-product-has-no-suppliers-configured"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c(
                            "w-row",
                            { attrs: { "no-wrap": "" } },
                            [
                              _vm.isLoaded
                                ? _c("w-tabs", {
                                    attrs: { tabs: _vm.sellerTabs },
                                    model: {
                                      value: _vm.openedSeller,
                                      callback: function ($$v) {
                                        _vm.openedSeller = $$v
                                      },
                                      expression: "openedSeller",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.supplier
                    ? [
                        _c(
                          "w-row",
                          { style: { zIndex: 100 } },
                          [
                            _c(
                              "w-col",
                              { attrs: { xs: "12", md: "6" } },
                              [
                                _vm.supplierContact
                                  ? _c("app-label", {
                                      attrs: {
                                        value:
                                          _vm.supplierContact.getDisplayName(),
                                        label: _vm.$ct("labels.sellerName"),
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "w-col",
                              { attrs: { xs: "12", md: "6" } },
                              [
                                _vm.supplier
                                  ? _c("app-label", {
                                      attrs: {
                                        value: _vm.supplier.IsMainSupplier,
                                        label: _vm.$ct("labels.isMainSupplier"),
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-row",
                          [
                            _c(
                              "w-col",
                              { attrs: { xs: "12", md: "6" } },
                              [
                                _c("app-label", {
                                  attrs: {
                                    label: _vm.$ct("labels.codeManufacturer"),
                                    value: _vm.supplier.ManufacturerCode,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "w-col",
                              { attrs: { xs: "12", md: "6" } },
                              [
                                _c("app-label", {
                                  attrs: {
                                    label: _vm.$ct("labels.codeSupplier"),
                                    value: _vm.supplier.SupplierCode,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.canSeeSellPrices
                          ? _c(
                              "w-row",
                              [
                                _c(
                                  "w-col",
                                  {
                                    style: { flexDirection: "row" },
                                    attrs: { xs: "6", md: "5" },
                                  },
                                  [
                                    _vm.isAllowedMultiValuta
                                      ? _c("app-label", {
                                          staticClass: "mrs",
                                          style: {
                                            flexShrink: 0,
                                            width: "auto",
                                            minWidth: "60px",
                                          },
                                          attrs: {
                                            label: _vm.$ct("labels.currency"),
                                            value: _vm.currencyPrefix,
                                          },
                                        })
                                      : _vm._e(),
                                    _c("app-label", {
                                      style: { flexGrow: 1 },
                                      attrs: {
                                        label: _vm.$ct("labels.catalogPrice"),
                                        value: _vm.catalogPrice,
                                        decimals: _vm.decimals,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-col",
                                  { attrs: { xs: "6", md: "2" } },
                                  [
                                    _c("app-label", {
                                      attrs: {
                                        label: "%",
                                        value: _vm.percentage,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-col",
                                  { attrs: { xs: "12", md: "5" } },
                                  [
                                    _c("app-label", {
                                      attrs: {
                                        label: _vm.$ct("labels.nettoPrice"),
                                        value: _vm.nettoPrice,
                                        decimals: _vm.decimals,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "w-row",
                          { style: { zIndex: 50 } },
                          [
                            _c(
                              "w-col",
                              { attrs: { xs: "12" } },
                              [
                                _c("app-label", {
                                  attrs: {
                                    label: _vm.$ct("labels.brand"),
                                    value: _vm.supplier.Brand,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }